import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import clickOutside from "./directives/clickOutside";
import { dropdown, dropdownTrigger, dropdownContent } from "./directives/dropdown";
import alertPlugin from "./plugins/alert";
import axiosConfig from "./config/axios";
import errorHandler from "./services/errorHandler";
import { useAuthStore, sincronizarEntrePestanas } from "./stores/auth";
import naive from "naive-ui";

import "./index.scss";

// console.log(import.meta.env);

window.addEventListener("beforeunload", async () => {
  try {
    // await clear();
  } catch (error) {
  }
});

// La key de alertas leídas se renombró a "readAlerts"; purgamos la antigua
// "readNotifications" para que no quede huérfana en localStorage (sin migrar datos).


if (import.meta.env.MODE !== "development") {
  window.consoleHolder = window.console;
  window.console = {};
  Object.keys(window.consoleHolder).forEach((key) => {
    console[key] = () => {};
  });
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.config.warnHandler = () => {};

app.directive("click-outside", clickOutside);
app.directive("dropdown", dropdown);
app.directive("dropdown-trigger", dropdownTrigger);
app.directive("dropdown-content", dropdownContent);

// Inicializar errorHandler con i18n para traducciones
errorHandler.setI18n(i18n);

app.use(pinia);

// Antes de montar: mismo token que App.vue (los hijos montan antes que App.onMounted)
const _auth = useAuthStore();
const _t = _auth.token || _auth.tokenManager;
if (_t) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${_t}`;
}

sincronizarEntrePestanas(() => {
  if (router.currentRoute.value.matched.some((r) => r.meta.requiresAuth)) router.push("/login");
});

// Configurar interceptores de axios para manejo automático de token expirado
axiosConfig.setupInterceptors();

// Exponer errorHandler globalmente para testing (solo en desarrollo)
if (import.meta.env.MODE === "development") {
  window.__testErrorHandler__ = {
    testServerError: (status = 500) => {
      errorHandler.handleServerError(
        {
          config: { url: "/test-endpoint" },
          message: `Test error ${status}`,
        },
        status,
      );
    },
    testConnectionError: () => {
      errorHandler.handleConnectionError({
        message: "Network Error",
        code: "ECONNREFUSED",
        config: { url: "/test-endpoint" },
      });
    },
    testInfo: () => {
      errorHandler.testNotification();
    },
  };
}

app.use(router).use(i18n).use(alertPlugin).use(naive).mount("#app");

// https://medium.com/simform-engineering/globalize-your-vue-app-a-practical-guide-to-vue-3-internationalization-93f5c7da4494
// https://lokalise.com/blog/vue-i18n/
// https://stackoverflow.com/questions/68802337/vue-js-i18n-load-external-jsons-from-server-and-make-it-globally-accessible-i
